import { login, logout, getInfo, refreshToken } from '@/api/login'
import { getToken, setToken, setExpiresIn, removeToken } from '@/utils/auth'
import {getCustomerInfo} from "../api/login";

const user = {
  namespaced: true,
  state: {
    token: getToken(),
    id: '',
    userName: '',
    avatar: '',
    roles: [],
    permissions: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_NAME: (state, name) => {
      state.userName = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    RESET_INFO: (state) => {
      state.userName = ''
      state.avatar = ''
      state.id = ''
      state.token = ''
    }
  },

  actions: {
    // 登录
    Login({ commit }, data) {
      // console.log(token, 'token0000')
      setToken(data.token)
      commit('SET_TOKEN', data.token)
      commit('SET_ID', data.userId)
      // setExpiresIn(data.expires_in)
      // commit('SET_EXPIRES_IN', data.expires_in)
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getCustomerInfo(state.id).then(res => {
          if (res.status === 200) {
            if (res.data.code === 0) {
              const user = res.data.data
              // console.log(res, user, '人员信息')
              const avatar = (user.avatar == "" || user.avatar == null) ? require("@/assets/img/img.png") : process.env.VUE_APP_FILE_API + user.avatar;
              if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                commit('SET_ROLES', res.roles)
                commit('SET_PERMISSIONS', res.permissions)
              } else {
                commit('SET_ROLES', ['ROLE_DEFAULT'])
              }
              commit('SET_ID', user.userId)
              commit('SET_NAME', user.username)
              commit('SET_AVATAR', avatar)
              resolve(res)
            }
          }

        }).catch(error => {
          reject(error)
        })
      })
    },

    // 刷新token
    RefreshToken({commit, state}) {
      return new Promise((resolve, reject) => {
        refreshToken(state.token).then(res => {
          setExpiresIn(res.data)
          commit('SET_EXPIRES_IN', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ID', '')
          commit('SET_NAME', '')
          commit('SET_AVATAR', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/user.js